/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingMessage } from '../shared/LoadingMessage';
import { getHostName, publishNewRelicCustomAttribute, isLLC, updateDeliveryZip } from '../../util/utils';

export const WRENAuth = ({ requestBody }) => {

  const apiKey = requestBody['x-api-key'];
  const deliveryZip = requestBody.deliveryZip;
  const externalAssociateID = requestBody.externalAssociateID;
  const externalOrderId = requestBody.externalOrderId;

  const d = '.' + window.location.hostname;

  const validateToken = async () => {
    return await fetch(getHostName() + '/storefront/auth/validate/wren', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        externalOrderId,
        externalAssociateID,
        apiKey
      }),
    });
  };

  const saveDataToCookie = () => {
    if (isLLC()) {
      // set llc cookie for stage
      document.cookie = 'llc-env=q2|9061; path=/; domain=' + d + '; Secure; max-age=86400';
    }
  };

  useEffect(() => {
    saveDataToCookie();
    if (apiKey) {
      validateToken()
      .then((r) => r.json())
      .then((r) => {
        if (r.success) {
          publishNewRelicCustomAttribute({ tagName: 'storefrontUserType', tagValue: 'WREN' });
          if (deliveryZip) {
            updateDeliveryZip(deliveryZip)
              .then(() => location.href = '/')
              .catch(() => location.href = '/');
            return;
          }
        }
        location.href = '/';
      })
      .catch((e) => {
        console.log('error: ', e);
        location.href = '/';
      });
    } else {
      location.href = '/';
    }
  }, []);

  return (
    <LoadingMessage loadingText="Welcome! Authentication is in progress..." />
  );
};

WRENAuth.propTypes = {
  requestBody: PropTypes.object,
};

WRENAuth.defaultProps = {
  requestBody: {},
};